import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices } from 'index';

type Callbacks = {
  onSuccess?: () => void;
  onSettled?: () => void;
};

export const useSendModuleToTranslationV2 = (moduleId: string, callbacks?: Callbacks) => {
  const service = useServices().moduleListV2Service;
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => service.sendToTranslation(moduleId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['adminModuleV2', moduleId] });
      callbacks?.onSuccess?.();
    },
    onSettled: callbacks?.onSettled,
  });
};
